import { AbgSxProps } from '@abg/typings';

export const errorBannerStyling: AbgSxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  padding: '12px 16px',
};

export const errorIconStyling: AbgSxProps = {
  fontSize: '12px',
};
